import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M2 10.001V14h3.998v1H1v-4.999h1zm13 0V15h-4.999v-1H14v-3.999h1zM8 5.999A2.001 2.001 0 1 1 8 10 2.001 2.001 0 0 1 8 6zM15 1v4.998h-1V2h-3.999V1H15zM5.998 1v1H2v3.998H1V1h4.998z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }